import { render, staticRenderFns } from "./CadastreSideMenu.vue?vue&type=template&id=87a9e382&scoped=true"
import script from "./CadastreSideMenu.vue?vue&type=script&lang=js"
export * from "./CadastreSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CadastreSideMenu.vue?vue&type=style&index=0&id=87a9e382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a9e382",
  null
  
)

export default component.exports